export enum COMMUNICATION_REMINDER_MEDIUM {
  SLACK = 'slack',
  EMAIL = 'email'
}

/**
 * Normalized reminder type that combines common properties from SlackReminder and EmailReminder
 * with the medium field for unified handling in the UI
 */
export interface NormalizedReminder {
  id: number;
  title: string; // normalized from SlackReminder.title or EmailReminder.subject
  message: string;
  datetime: string;
  notifyStatus: number;
  selectedGuestStatuses: number[];
  schedule: {
    quantity: number;
    unit: string;
    beforeEventBegins: boolean;
  };
  medium: COMMUNICATION_REMINDER_MEDIUM;
}

export enum EPOCH_COMMUNICATION_TYPE {
  // Primary feedback
  FEEDBACK = 'feedback',
  // Resend feedback
  RESEND_FEEDBACK = 'resend_feedback',
  REMINDER = 'reminder',
  EVENT_QUESTIONNAIRE = 'event_questionnaire',
  SELF_CHECK_IN = 'self_check_in'
}

export enum EPOCH_COMMUNICATION_STATUS {
  SCHEDULED = 'scheduled',
  SENT = 'sent',
  FAILED = 'failed',
  RECURRING = 'recurring'
}

export interface EPOCH_COMMUNICATION_NOTIFICATION {
  id: number;
  title: string;
  message: string;
  mediums: COMMUNICATION_REMINDER_MEDIUM[];
  type: EPOCH_COMMUNICATION_TYPE;
  targetStatuses: string[];
  status: EPOCH_COMMUNICATION_STATUS;
  sendAt: string;
}
